import React from 'react';
import Products from './Products';

const Layout = () => {
  return <Products />;
};

export default Layout;
